<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  // 页面刷新方法
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isNaN: true
    }
  },
  created () {},
  methods: {
    reload () {
      this.isNaN = false
      this.$nextTick(function () {
        this.isNaN = true
      })
    }
  },
  computed: {},
  watch: {},
  components: {}
}
</script>

<style lang="less" scoped>
</style>
